module.exports = "<div class=\"treatment-cell {{#Model.FilteredOut}}filtered-out{{/Model.FilteredOut}}\" id=\"{{Model.Id}}\">\r\n    {{#Model.Id}}<img src=\"assets/images/flags/24/{{Model.IconUrl}}\" title=\"{{Model.DisplayJurisdiction}}\" width=\"24\" height=\"24\" class=\"jd-flag\" />{{/Model.Id}}\r\n    {{Model.Title}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/desktop/views/partials/category-legislation-relation.html
// module id = 347
// module chunks = 1